import { render, staticRenderFns } from "./NavbarService.vue?vue&type=template&id=5e8737e8&scoped=true&"
import script from "./NavbarService.vue?vue&type=script&lang=js&"
export * from "./NavbarService.vue?vue&type=script&lang=js&"
import style0 from "./NavbarService.vue?vue&type=style&index=0&id=5e8737e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8737e8",
  null
  
)

export default component.exports